module.exports = __webpack_public_path__ + "img/chauffe-marcel_01_icone.654be2dd.svg";